import React, { useEffect, useRef, useState } from 'react';

import {
    Box,
    Breadcrumbs,
    Divider,
    Link,
    Stack,
    Typography,
    Paper,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    InputAdornment,
    IconButton,
    List,
    ListSubheader,
    ListItemButton,
    ListItemText,
    ListItemIcon,
    ListItem,
    Chip,
    Skeleton,
    FormControl,
    Grid,
    styled
} from '@mui/material';

import { useSystemPrompt } from '../../hooks/useSystemPrompt';
// import { useRetailMembers } from '../../hooks/api/useRetailMembers'
import { useUsers, userTypes, targetTypes } from '../../hooks/api/useUsers';
import { CommonIcons, icons } from '../common/CommonIcons';
import { useTranslations } from '../../hooks/useTranslations';

const StyledIcon = styled(Box)(({ theme }) => ({
    // width: 40,
    // height: 40,
    // opacity: 0.1,
    //   backgroundColor: "green",
    //   color: 'inherit',
    //   display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
}));


const StyledTitle = styled(Box)(({ theme }) => ({
    fontWeight: 800,
    fontSize: '1.0rem'
}))

const StyledSubTitle = styled(Box)(({ theme }) => ({
    fontWeight: 300,
    fontSize: '0.8rem'
}))

export default function SearchRetailMembers(
    {
        id,
        ownerId,
        handleOnCancel,
        handleOnSelect,
        handleOnSearchChange,
        textProps
    }
) {
    const { t } = useTranslations({ ns: ["common", "@document"] })

    const searchInputRef = useRef()

    const [open, setOpen] = useState(false)
    const [keyword, setKeyword] = useState("")
    const [data, setData] = useState([])

    const { promptMessage } = useSystemPrompt()
    // const { isLoading, list, filterOperatorTypes } = useRetailMembers();  
    const { isLoading, list, filterOperatorTypes } = useUsers({ userType: userTypes.member, targetType: targetTypes.retail })

    const fetchData = async () => {

        try {

            let props = {
                limit: 30,
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: -1,
                },
                filterValue: [
                    {
                        name: "firstname",
                        operator: filterOperatorTypes.contains,
                        value: keyword
                    },
                    // {
                    //     name: "lastname",
                    //     operator: filterOperatorTypes.contains,
                    //     value: keyword
                    // },
                    {
                        name: "owner_id",
                        operator: filterOperatorTypes.eq,
                        value: ownerId
                    }
                ]
            }

            let response = await list(props);

            setData(response?.data?.members ? response?.data?.members : [])

        } catch (error) {
            promptMessage(false, `${error.message}`)
        }

    }

    useEffect(() => {

        setData([])
        setKeyword("")

    }, [ownerId])


    useEffect(() => {

        const timeout = setTimeout(() => {

            if (open) {
                searchInputRef?.current.focus();
                // console.log('serachRef', searchInputRef?.current)
            }

        }, 100);

        return () => {
            clearTimeout(timeout);
        };

    }, [open])

    useEffect(() => {

        if (keyword) {
            fetchData({ keyword });
        } else {
            setKeyword("")
            setData([])
        }

    }, [keyword])

    const RenderListData = () => {

        if (isLoading) {
            return (
                [1, 2, 3, 4].map((item, index) => <RenderListDataItem key={index} isLoading={Boolean(true)} />)
            )
        }

        return (
            data.map((item, index) =>
                <RenderListDataItem key={index} item={item} index={index} />
            )
        )
    }

    const RenderListDataItemSkeleton = () => {
        return (
            <>
                <Skeleton
                    animation="wave"
                    // variant="circular" 
                    sx={{
                        minWidth: 100,
                        mr: 1,
                        height: 50
                    }}
                />
                <ListItemText
                // fullWidth
                // height={50}
                >
                    <Skeleton
                        variant="rectangular"
                        width={"100%"}
                        height={20}
                    />
                    <Skeleton
                        variant="rectangular"
                        width={"100%"}
                        height={20}
                        sx={{
                            mt: 1
                        }}
                    />
                </ListItemText>
            </>
        )
    }

    const RenderListDataItemDisplay = ({ item }) => {
        return (
            <>
                {/* <Chip 
                    label={item?.account_code? item?.account_code : "-"} 
                    sx={{ 
                        mr: 1,
                        minWidth: 100
                    }} 
                    // size="small" 
                    color="primary" 
                /> */}
                <Grid container padding={1}>
                    <Grid item md={1} textAlign={"center"}>
                        <CommonIcons name={icons.members} sx={{ width: 35, height: 35 }} />
                    </Grid>
                    <Grid item md={7}>
                        <StyledTitle>
                            {`${item?.firstname} ${item?.lastname}`}
                        </StyledTitle>
                        <StyledSubTitle>
                            {`${item?.company_name}`}
                        </StyledSubTitle>
                    </Grid>
                    <Grid item md={4} textAlign={"right"}>
                        <Stack
                            direction={"row"}
                        >
                            <StyledIcon>
                                <CommonIcons name={icons.mobile} />
                            </StyledIcon>
                            <StyledSubTitle sx={{ ml: 1 }}>
                                {item?.contact}
                            </StyledSubTitle>
                        </Stack>
                        <Stack
                            direction={"row"}
                        >
                            <StyledIcon>
                                <CommonIcons name={icons.email} />
                            </StyledIcon>
                            <StyledSubTitle sx={{ ml: 1 }}>
                                {item?.email}
                            </StyledSubTitle>
                        </Stack>
                    </Grid>
                </Grid>
            </>
        )
    }

    const RenderListDataItem = ({ isLoading = false, index, item }) => {
        return (
            <ListItem
                key={index}
                disablePadding
                divider
            >
                <ListItemButton
                    role={undefined}
                    onClick={() => {
                        // handleOnCancel();
                        handleSelect({ item, id });
                    }}
                    dense
                >
                    {
                        Boolean(isLoading) ? <RenderListDataItemSkeleton /> : <RenderListDataItemDisplay item={item} />

                    }

                </ListItemButton>
            </ListItem>
        )
    }

    const RenderList = () => {

        return (
            <List
                autoFocus
                // sx={{ width: '100%', maxWidth: 360,
                //     bgcolor: 'background.paper' }}
                component="nav"
                aria-labelledby="nested-list-subheader"
                subheader={
                    <ListSubheader
                        component="div"
                        id="nested-list-subheader"
                        sx={{
                            // backgroundColor: 'red'
                            // pl: 1,
                            // pr: 1
                        }}
                    >
                        <Paper
                            elevation={3}
                            sx={{
                                p: 1,
                            }}
                        >
                            {/* <FormControl variant="standard"> */}
                            <TextField
                                inputRef={searchInputRef}
                                autoComplete="off"
                                margin="dense"
                                size="small"
                                label={t("searchKeyword")}
                                fullWidth
                                variant="outlined"
                                onChange={e => {
                                    setKeyword(e.target.value)
                                    // fetchData({ keyword });
                                }}
                                value={keyword}
                                InputProps={{
                                    startAdornment:
                                        <InputAdornment position="start">
                                            <CommonIcons name={icons.search} />
                                        </InputAdornment>
                                }}
                            />
                            {/* </FormControl> */}
                        </Paper>
                    </ListSubheader>
                }
            >
                {
                    RenderListData()
                }

            </List>
        )
    }

    const handleExit = () => {
        setOpen(false);

        if (handleOnCancel)
            handleOnCancel();
    }

    const handleSelect = ({ id, item }) => {
        setOpen(false);

        if (handleOnSelect)
            handleOnSelect({ id, item })

        promptMessage(true, `Selected (1) item`)
    }

    const RenderSearch = () => {
        return (
            <TextField
                disabled={textProps?.disabled ? textProps.disabled : false}
                margin="normal"
                size="small"
                fullWidth
                name={id}
                label={t("selectMember")}
                type="text"
                variant="outlined"
                value={textProps?.value ? textProps.value : ""}
                onChange={(val) => handleOnSearchChange(val)}
                error={textProps?.error ? textProps.error : false}
                helperText={textProps?.helperText}
                InputProps={{
                    style: {
                        paddingRight: 5
                    },
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                sx={{
                                    m: 0,
                                    // p: 0
                                }}
                                aria-label="open"
                                onClick={() => setOpen(true)}
                            >
                                <CommonIcons name={icons.search} />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
        )
    }

    return (
        <Box>

            {RenderSearch()}

            <Dialog
                sx={{
                    '& .MuiDialog-paper':
                    {
                        // width: '80%', 
                        minHeight: '90vh'
                    }
                }}
                disableRestoreFocus={false}
                fullWidth
                maxWidth="md"
                // TransitionProps={{ onEntering: handleEntering }}
                open={open}
                // {...other}
                onClose={handleExit}

            >
                <DialogTitle
                >
                    {t('searchRetailMember')}

                    <IconButton
                        aria-label="close"
                        onClick={handleExit}
                        sx={{
                            position: 'absolute',
                            right: 10,
                            top: 10,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CommonIcons name={icons.close} />
                    </IconButton>

                </DialogTitle>
                <DialogContent
                    dividers
                    // minHeight="100%"
                    sx={{
                        // backgroundColor: 'red',
                        pl: 0,
                        pr: 0
                    }}
                >

                    {
                        RenderList()
                    }

                </DialogContent>
                {/* <DialogActions>
                    <Button 
                        autoFocus 
                        // onClick={handleCancel}
                        onClick={() => {
                            handleOnCancel()
                        }}
                    >Cancel</Button>
                    <Button 
                        // onClick={handleOk}
                        onClick={() => {
                            handleOnConfirm()
                        }}
                    >Ok</Button>
                </DialogActions> */}
            </Dialog>
        </Box>
    )
}